export function parseAdminEmails(raw) {
  return String(raw || "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

export function isAdminEmail(email) {
  const admins = parseAdminEmails(process.env.REACT_APP_ADMIN_EMAILS);
  console.log("admins", admins);
  const e = String(email || "")
    .trim()
    .toLowerCase();

  console.log(e);
  return !!e && admins.includes(e);
}
